// extracted by mini-css-extract-plugin
module.exports = {"content":"PercentDepositsConfirmation_content__RTTSj","block":"PercentDepositsConfirmation_block__3N73g"};